import { createSlice } from '@reduxjs/toolkit';

interface CreationFlowEntry {
  step?: number;
  knowledgeBaseId?: string;
  formData?: Record<string, unknown>;
  promptType?: string;
  promptBuilderSettingsId?: string;
  manualSettingsId?: string;
  finished?: boolean;
  popupShowed?: boolean;
}

interface CreationFlowState {
  [projectId: string]: CreationFlowEntry;
}

const initialState: CreationFlowState = {};

export const creationFlowSlices = createSlice({
  name: 'creationFlowSlices',
  initialState: { ...initialState },
  reducers: {
    setCreationFlow(state, action) {
      const projectState = state[action.payload.id] || {};
      const newState = { ...projectState, step: action.payload.step };

      if (action.payload.knowledgeBaseId !== undefined) {
        newState.knowledgeBaseId = action.payload.knowledgeBaseId;
      }

      if (action.payload.formData !== undefined) {
        newState.formData = action.payload.formData;
      }

      if (action.payload.promptType !== undefined) {
        newState.promptType = action.payload.promptType;
      }

      if (action.payload.promptBuilderSettingsId !== undefined) {
        newState.promptBuilderSettingsId = action.payload.promptBuilderSettingsId;
      }

      if (action.payload.manualSettingsId !== undefined) {
        newState.manualSettingsId = action.payload.manualSettingsId;
      }

      if (action.payload.finished !== undefined) {
        newState.finished = action.payload.finished;
      }

      if (action.payload.popupShowed !== undefined) {
        newState.finished = action.payload.popupShowed;
      }

      state[action.payload.id] = newState;
    },
    removeCreationFlow(state, action) {
      delete state[action.payload.id];
    },
  },
});

export const { setCreationFlow, removeCreationFlow } = creationFlowSlices.actions;

export default creationFlowSlices.reducer;
